import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { routesActions, routesSelectors } from 'store/modules/routes';
export const UserRoutesContext = React.createContext<UserRoutesProviderValue | null>(null);
export function UserRoutesProvider(t0) {
  const $ = _c(6);
  const {
    children,
    fetchRoutes,
    isFetching
  } = t0;
  let t1;
  if ($[0] !== fetchRoutes || $[1] !== isFetching) {
    t1 = {
      fetchRoutes,
      isFetching
    };
    $[0] = fetchRoutes;
    $[1] = isFetching;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <UserRoutesContext value={t1}>{children}</UserRoutesContext>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
interface UserRoutesProviderValue {
  fetchRoutes: () => any;
  isFetching?: boolean;
}
interface UserRoutesProviderProps extends UserRoutesProviderValue {
  children: React.ReactNode;
}
const mapStateToProps = (state: any, {
  disabled
}: {
  disabled?: boolean;
}) => ({
  isFetching: routesSelectors.getIsFetching(state),
  disabled
});
const mapDispatchToProps = {
  fetchRoutes: routesActions.fetchRoutes
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(UserRoutesProvider));
export const UserRoutesConsumer = UserRoutesContext.Consumer;